import React, { useState } from 'react';
import {
  createDamperPedalEvent,
  createNoteEvent,
} from '../../sharedTypes/pureHelpers';
import { ManagerEntity } from '@/shared/globalFunctions';

const EventsSender = () => {
  const [noteOnPitch, setNoteOnPitch] = useState<number | undefined>();
  const [noteOffPitch, setNoteOffPitch] = useState<number | undefined>();
  return (
    <div
      style={{
        position: 'fixed',
        top: '0px',
        left: '65%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: 'white',
        padding: '10px',
        borderRadius: '5px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        pointerEvents: 'auto',
        width: 'auto',
        display: 'block',
        visibility: 'visible'
      }}>
      <div>
        damperPedalOn
        <button
          onClick={() => {
            const event = createDamperPedalEvent(127);
            ManagerEntity.player?.onMidiMessage(event);
          }}
          id='damperPedalOnSendButton'>
          send
        </button>
      </div>
      <div>
        damperPedalOff
        <button
          onClick={() => {
            const event = createDamperPedalEvent(0);
            ManagerEntity.player?.onMidiMessage(event);
          }}
          id='damperPedalOffSendButton'>
          send
        </button>
      </div>
      <div>
        noteOn
        <input
          type='number'
          onChange={(e: any) => {
            setNoteOnPitch(parseInt(e.target.value));
          }}
          id='noteOnSendInput'></input>
        <button
          onClick={() => {
            if (noteOnPitch) {
              const event: any = createNoteEvent(noteOnPitch);
              event.type = 'noteon';
              ManagerEntity.player?.noteOn(event);
            }
          }}
          id='noteOnSendButton'>
          send
        </button>
      </div>
      <div>
        noteOff
        <input
          type='number'
          onChange={(e: any) => {
            setNoteOffPitch(parseInt(e.target.value));
          }}
          id='noteOffSendInput'></input>
        <button
          id='noteOffSendButton'
          onClick={() => {
            if (noteOffPitch) {
              const event: any = createNoteEvent(noteOffPitch);
              event.type = 'noteoff';
              ManagerEntity.player?.noteOff(event);
            }
          }}>
          send
        </button>
      </div>
    </div>
  );
};
export default EventsSender;
